import { createActionGroup, emptyProps, props } from '@ngrx/store'
import { CaseTreeNode } from './cases.state'
import { HttpErrorResponse } from '@angular/common/http'

export const casesActions = createActionGroup({
    source: 'Case',
    events: {
        'Load Cases': emptyProps(),
        'Cases Loaded': props<{ cases: CaseTreeNode[] }>(),
        'Delete Folder': props<{ folderId: number }>(),
        'Deleting Folder Succeeded': emptyProps(),
        'Deleting Folder Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Move Folder': props<{ folderId: number; parentId: number | null }>(),
        'Moving Folder Succeeded': emptyProps(),
        'Moving Folder Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Create Folder': props<{ name: string; parentId: number | null }>(),
        'Creating Folder Succeeded': props<{ parentId: number | null }>(),
        'Creating Folder Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Move Dataset': props<{ datasetId: number; parentId: number | null }>(),
        'Moving Dataset Succeeded': emptyProps(),
        'Moving Dataset Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Delete Dataset': props<{ datasetId: number }>(),
        'Deleting Dataset Succeeded': emptyProps(),
        'Deleting Dataset Failed': props<{ error: HttpErrorResponse; message: string }>(),
        'Set Expanded Folders': props<{ folderIds: number[] }>(),
        'Creating Dataset Succeeded': emptyProps(),
    },
})
